import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-390">
      <div className="max-w-5xl mx-auto" data-id="element-391">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-392">
          Lo que <span className="text-[#39FF14]" data-id="element-393">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-394">
          <div className="bg-black border border-[#39FF14]/30 rounded-2xl p-6" data-id="element-395">
            <h3 className="text-[#39FF14] text-xl font-black mb-2" data-id="element-396">
              🇧🇷 TODOS LOS NIVELES — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-397">
              Para docentes de Portugués de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-398">
              <div className="flex items-center gap-3 text-white" data-id="element-399">
                <span className="text-xl" data-id="element-400">📘</span>
                <div className="flex-1" data-id="element-401">
                  <span className="font-bold" data-id="element-402">Tomo 1 — Nivel 1:</span>
                  <span className="text-gray-300" data-id="element-403">
                    {' '}
                    Primeiros Passos (Alfabeto, colores, números, animales,
                    familia y saludos.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-404">
                <span className="text-xl" data-id="element-405">📗</span>
                <div className="flex-1" data-id="element-406">
                  <span className="font-bold" data-id="element-407">Tomo 2 — Nivel 2:</span>
                  <span className="text-gray-300" data-id="element-408">
                    {' '}
                    Explorando o Português (Rutina, alimentación, vestuario,
                    verbos en presente y los lugares de la ciudad.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-409">
                <span className="text-xl" data-id="element-410">📙</span>
                <div className="flex-1" data-id="element-411">
                  <span className="font-bold" data-id="element-412">Tomo 3 — Nivel 3:</span>
                  <span className="text-gray-300" data-id="element-413">
                    {' '}
                    Conexão Brasil Nível 1 (Identidad, Falsos Amigos (Top 25),
                    verbos irregulares, mundo digital y Pretérito Perfeito.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-414">
                <span className="text-xl" data-id="element-415">📕</span>
                <div className="flex-1" data-id="element-416">
                  <span className="font-bold" data-id="element-417">Tomo 4 — Nivel 4:</span>
                  <span className="text-gray-300" data-id="element-418">
                    {' '}
                    Conexão Brasil Nível 2 (Pretérito Imperfeito, Futuro,
                    viajes, debate y textos auténticos de actualidad.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-419">
                <span className="text-xl" data-id="element-420">📓</span>
                <div className="flex-1" data-id="element-421">
                  <span className="font-bold" data-id="element-422">Tomo 5 — Nivel 5:</span>
                  <span className="text-gray-300" data-id="element-423">
                    {' '}
                    Fluência e Cultura (Subjuntivo, Imperativo, literatura
                    brasileña, cine, música y Português profesional.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-424">
                <span className="text-xl" data-id="element-425">📔</span>
                <div className="flex-1" data-id="element-426">
                  <span className="font-bold" data-id="element-427">Tomo 6 — Nivel 6:</span>
                  <span className="text-gray-300" data-id="element-428">
                    {' '}
                    Português Avançado (Fonética avanzada, ensayos académicos,
                    simulacros CELPE-Bras y Portfolio de cierre.)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#39FF14]/5 border border-[#39FF14]/30 rounded-2xl p-8 text-center" data-id="element-429">
          <h3 className="text-[#39FF14] text-xl font-black mb-6" data-id="element-430">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-431">
            <div className="flex items-start gap-2 text-left" data-id="element-432">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-433">✅</span>
              <span className="text-white text-sm" data-id="element-434">
                Planificación anual lista para jefatura
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-435">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-436">✅</span>
              <span className="text-white text-sm" data-id="element-437">
                6 Unidades Didácticas completas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-438">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-439">✅</span>
              <span className="text-white text-sm" data-id="element-440">
                Secuencias inicio–desarrollo–cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-441">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-442">✅</span>
              <span className="text-white text-sm" data-id="element-443">
                Actividades fotocopiables (3 niveles A/B/C)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-444">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-445">✅</span>
              <span className="text-white text-sm" data-id="element-446">
                Evaluaciones + integradora con criterios
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-447">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-448">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-449">
                SOLUCIONARIO COMPLETO
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-450">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-451">✅</span>
              <span className="text-white text-sm" data-id="element-452">
                Sección "Falsos Amigos" en todos los niveles
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-453">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-454">✅</span>
              <span className="text-white text-sm" data-id="element-455">
                Alineado al currículo argentino vigente
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}